import { render, staticRenderFns } from "./infoEditList.vue?vue&type=template&id=397b97d0&scoped=true"
import script from "./infoEditList.vue?vue&type=script&lang=ts"
export * from "./infoEditList.vue?vue&type=script&lang=ts"
import style0 from "./infoEditList.vue?vue&type=style&index=0&id=397b97d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b97d0",
  null
  
)

export default component.exports